\
<template>
    <CardContentPanel icon="conditions" v-bind="{action, index}">
        <template #title>
            {{ $t('projectclient.projectview.activity.pending.actions.REVIEW_EXPENSE_BATCH.title') }}
        </template>
        <template #body="{freelancerName}">
            {{ $t('projectclient.projectview.activity.pending.actions.REVIEW_EXPENSE_BATCH.description', {0: freelancerName}) }}
        </template>
        <template #actions>
            <NuxtLink
                :to="`/project/${projectInformation.projectId}/expense-validation?batch=${action.extraData.expenseBatchId}&origin=project-view`"
                data-testid="pending-action-card-cta-primary"
            >
                <VJoyButton variant="main" size="small">
                    {{ $t('projectclient.projectview.activity.pending.actions.REVIEW_EXPENSE_BATCH.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import {useProjectInformationStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'REVIEW_EXPENSE_BATCH'>;
        index: number;
    }>();

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);
</script>
